import { actionKitImpFunction } from '../../../../../../components/ozmoit/common';
import {
  StudentWarningObservationDetailsResponse,
  StudentWarningsObservationDetailsParams,
} from '../types';
import request from '../../../../../../api/request';

const getDetailsAction = actionKitImpFunction(
  async (params: StudentWarningsObservationDetailsParams) => {
    const response = await request<StudentWarningObservationDetailsResponse>(
      `maintainers-portal/student-warnings/observations/details`,
      {
        params: {
          ...params,
        },
      },
    );
    if (response.error) {
      throw new Error('Error fetching student data');
    }
    return response.data;
  },
);

export { getDetailsAction };
